import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  effect,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { LnProductInfoDetailComponent } from '@components/ln-product-info-detail/ln-product-info-detail.component';
import { LnProductInfoThumbnailsComponent } from '@components/ln-product-info-thumbnails/ln-product-info-thumbnails.component';
import { LnProductInfoMainImageComponent } from '@components/ln-product-info-main-image/ln-product-info-main-image.component';
import { LnAcordeonParagraphComponent } from '@components/ln-acordeon-paragraph/ln-acordeon-paragraph.component';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { LnArrowBackSvgIconComponent } from '@components/svg-icons/ln-arrow-back-svg-icon/ln-arrow-back-svg-icon.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { ActivatedRoute } from '@angular/router';
import { ProductsService } from '@core/services/products/products.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ApiResponse } from '@interfaces/api/api.interface';
import { ProductDetails } from '@interfaces/products/product_detail_interface';
import { OtherProductsOfLnHomeComponent } from '@components/other-products-of-ln-home/other-products-of-ln-home.component';
import { ScrollService } from '@core/services/scroll/scroll.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { LanguageService } from '@core/services/language/language.service';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-product-info',
  imports: [
    LnProductInfoDetailComponent,
    LnProductInfoThumbnailsComponent,
    LnProductInfoMainImageComponent,
    LnAcordeonParagraphComponent,
    LnPagesArmorComponent,
    LnArrowBackSvgIconComponent,
    OtherProductsOfLnHomeComponent,
    TranslocoPipe,
    NgClass,
  ],
  templateUrl: './ln-product-info.component.html',
  styleUrl: './ln-product-info.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnProductInfoComponent implements OnInit {
  readonly TAG = 'LnProductInfoComponent';
  protected selectedImageIndex = 0;
  private menuActions = inject(MenuActions);
  private productService = inject(ProductsService);
  private destroyRef = inject(DestroyRef);
  private routes = inject(ActivatedRoute);
  private sellerID: WritableSignal<string> = signal('');
  private productID: WritableSignal<string> = signal('');
  protected readonly productDetail: WritableSignal<ProductDetails | null> = signal(null);
  protected readonly selectedVariant: WritableSignal<number> = signal(0);
  private variantID?: string;
  private scroll = inject(ScrollService);
  private locale = inject(LanguageService);
  private currentLanguage = this.locale.getCurrentLanguage();
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;
  protected readonly artisanID = this.sellerID.asReadonly();

  ngOnInit(): void {
    this.getQueryParams();
  }

  constructor() {
    effect(() => {
      this.selectedVariant();
      this.productDetail();
      this.resetImageIndex();
      const currentLanguage = this.locale.currentLanguage();
      if (currentLanguage !== this.currentLanguage) {
        this.currentLanguage = currentLanguage;
        this.getProductDetails();
      }
    });
  }

  resetImageIndex(): void {
    this.selectedImageIndex = 0;
  }

  getQueryParams(): void {
    this.routes.queryParams.subscribe(params => {
      const sellerID = params['sellerID'];
      const mainProductID = params['mainProductID'];
      const productID: string | undefined = params['productID'];
      if (productID) {
        this.variantID = productID;
      }

      if (sellerID && mainProductID) {
        this.sellerID.set(sellerID);
        this.productID.set(mainProductID);
        this.getProductDetails();
      }
    });
  }

  getProductDetails(): void {
    this.productService
      .getProductDetail(this.sellerID(), this.productID())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: ApiResponse<ProductDetails>) => {
          if (res.success) {
            const productDetail = res.data;
            this.productDetail.set(productDetail);
            if (productDetail.productos.length > 0) {
              this.selectedVariant.set(0);
              if (this.variantID) {
                this.setSelectedVariant();
              }
            }
            //console.log(`${this.TAG}  productDetail details for product: ${productDetail.id}`);
            this.scroll.scrollToTop();
          }
        },
        error: err => {
          console.log(`${this.TAG} ${err}`);
        },
      });
  }

  navigateBack() {
    this.menuActions.navigateBack();
  }
  ChangeSelectedImage(index: number) {
    this.selectedImageIndex = index;
    console.log(`${this.TAG}  selectedImageIndex: ${this.selectedImageIndex}`);
  }

  setSelectedVariant() {
    const productos = this.productDetail()?.productos;
    if (productos) {
      const selectedVariant = productos.find(product => product.id == this.variantID);
      if (selectedVariant) {
        const selectedVariantIndex = productos.indexOf(selectedVariant);
        if (selectedVariantIndex >= 0) {
          this.selectedVariant.set(selectedVariantIndex);
        }
      }
    }
  }
}
